import { render, staticRenderFns } from "./TableDates.vue?vue&type=template&id=5ec9123e&scoped=true&"
import script from "./TableDates.vue?vue&type=script&lang=js&"
export * from "./TableDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec9123e",
  null
  
)

export default component.exports